import React, { useContext, useEffect, useState } from 'react'
import UserContext from '../../../../contexts/UserContext'
import axios from 'axios'
import {
  SelectInput,
  SelectOption,
} from './style'
import { headerAccessesTable, accessesTableRequiredFields } from '../utils'
import Validation from './validation'
import { useProfileContext } from '../../../../contexts/AccessesContext'
import { useSearchAccesses } from '../../../../contexts/SearchAccessesContext'
import LoadMoreButton from '../../../../components/Accesses/LoadMoreButton'
import TableFiltersContext from '../../../../contexts/TableFiltersContext'
import { GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/table-style'
import { useOutletContext } from 'react-router-dom'
import { PeopleOutletType } from '..'
import { TypeMainOutlet } from '../..'

interface user {
  id: number
  name: string
  email: string
  phone: string
  company: string
  status: number
  cnpj: string
  adminUser: boolean
  permissions: string[]
  approved: string
  profileId: number | null
}

const TableAccesses = () => {
  const { token } = useContext(UserContext)
  const [users, setUsers] = useState<user[]>([])
  const [updateUserData, setUpdateUserData] = useState(0)
  const { profiles, loadQuantity, fetchProfiles } = useProfileContext()
  const { accessesFilters } = useContext(TableFiltersContext)
  const { setTabIndex } = useOutletContext<PeopleOutletType>()
  const { search } = useOutletContext<TypeMainOutlet>()

  useEffect(() => {
    setTabIndex(0)
  }, [])
  
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/user/findAll`, {
        params: {
          search,
          loadQuantity: loadQuantity,
          filters: JSON.stringify(accessesFilters), // Stringify the filters
        },
      })
      .then((response) => {
        setUsers(response.data)
      })
      .catch((error) => {
        console.log('Ocorreu um erro ao obter os dados dos users', error)
      })
    fetchProfiles()
  }, [updateUserData, search, loadQuantity, accessesFilters])

  const updateProfileOfUser = async (
    idUser: number,
    idProfile: number | null,
  ) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/user/${idUser}`,
        { profileId: idProfile },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      setUpdateUserData((prev) => prev + 1)
    } catch (error) {
      console.error('Erro ao atualizar o perfil do usuário', error)
    }
  }

  return (
    <>
      <GlobalTable>
        <tbody>
          <HeaderLine>
            {headerAccessesTable.map((header) => (
              <Th key={header}>{header}</Th>
            ))}
          </HeaderLine>
          {users.map((user: any) => (
            <Tr key={user.id}>
              {accessesTableRequiredFields.map((field, index) => (
                <Td key={index}>
                    {field === 'profileId' ? (
                      <SelectInput
                        value={user.profileId || 0}
                        onChange={(e) =>
                          updateProfileOfUser(
                            user.id,
                            Number(e.target.value) || null,
                          )
                        }
                      >
                        <SelectOption value={0}>
                          Usuário sem perfil
                        </SelectOption>
                        {profiles.map((profile) => (
                          <SelectOption key={profile.id} value={profile.id}>
                            {profile.name}
                          </SelectOption>
                        ))}
                      </SelectInput>
                    ) : (
                      <>
                        {['approved', 'blocked', 'pendent', 'pending'].includes(
                          user[field],
                        ) ? (
                          <Validation
                            situation={user[field]}
                            id={user.id}
                            onUpdate={() =>
                              setUpdateUserData((prev) => prev + 1)
                            }
                          />
                        ) : (
                          <>
                            {field === 'adminUser'
                              ? user.profileId === 3
                                ? 'Admin'
                                : 'Comum'
                              : user[field]}
                          </>
                        )}
                      </>
                    )}
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </GlobalTable>
      <LoadMoreButton />
    </>
  )
}

export default TableAccesses
